export { ICommunicationType };
var ICommunicationType;
(function (ICommunicationType) {
    ICommunicationType["Email"] = "Email";
    ICommunicationType["Facebook"] = "Facebook";
    ICommunicationType["Instagram"] = "Instagram";
    ICommunicationType["Phone"] = "Phone";
    ICommunicationType["Skype"] = "Skype";
    ICommunicationType["Telegram"] = "Telegram";
    ICommunicationType["Website"] = "Website";
})(ICommunicationType || (ICommunicationType = {}));
export { ICompanyTaxation };
var ICompanyTaxation;
(function (ICompanyTaxation) {
    ICompanyTaxation["Ist"] = "IST";
    ICompanyTaxation["Kust"] = "KUST";
    ICompanyTaxation["Soll"] = "SOLL";
})(ICompanyTaxation || (ICompanyTaxation = {}));
export { IContactRelation };
var IContactRelation;
(function (IContactRelation) {
    IContactRelation["Client"] = "client";
    IContactRelation["Employee"] = "employee";
    IContactRelation["Other"] = "other";
    IContactRelation["Partner"] = "partner";
    IContactRelation["Shareholder"] = "shareholder";
})(IContactRelation || (IContactRelation = {}));
export { IContactType };
var IContactType;
(function (IContactType) {
    IContactType["Individual"] = "individual";
    IContactType["Institution"] = "institution";
    IContactType["Organization"] = "organization";
})(IContactType || (IContactType = {}));
export { ICurrencyCode };
var ICurrencyCode;
(function (ICurrencyCode) {
    ICurrencyCode["Aed"] = "AED";
    ICurrencyCode["Afn"] = "AFN";
    ICurrencyCode["All"] = "ALL";
    ICurrencyCode["Amd"] = "AMD";
    ICurrencyCode["Ars"] = "ARS";
    ICurrencyCode["Aud"] = "AUD";
    ICurrencyCode["Azn"] = "AZN";
    ICurrencyCode["Bam"] = "BAM";
    ICurrencyCode["Bdt"] = "BDT";
    ICurrencyCode["Bgn"] = "BGN";
    ICurrencyCode["Bhd"] = "BHD";
    ICurrencyCode["Bif"] = "BIF";
    ICurrencyCode["Bnd"] = "BND";
    ICurrencyCode["Bob"] = "BOB";
    ICurrencyCode["Brl"] = "BRL";
    ICurrencyCode["Bwp"] = "BWP";
    ICurrencyCode["Byn"] = "BYN";
    ICurrencyCode["Bzd"] = "BZD";
    ICurrencyCode["Cad"] = "CAD";
    ICurrencyCode["Cdf"] = "CDF";
    ICurrencyCode["Chf"] = "CHF";
    ICurrencyCode["Clp"] = "CLP";
    ICurrencyCode["Cny"] = "CNY";
    ICurrencyCode["Cop"] = "COP";
    ICurrencyCode["Crc"] = "CRC";
    ICurrencyCode["Cve"] = "CVE";
    ICurrencyCode["Czk"] = "CZK";
    ICurrencyCode["Djf"] = "DJF";
    ICurrencyCode["Dkk"] = "DKK";
    ICurrencyCode["Dop"] = "DOP";
    ICurrencyCode["Dzd"] = "DZD";
    ICurrencyCode["Eek"] = "EEK";
    ICurrencyCode["Egp"] = "EGP";
    ICurrencyCode["Ern"] = "ERN";
    ICurrencyCode["Etb"] = "ETB";
    ICurrencyCode["Eur"] = "EUR";
    ICurrencyCode["Gbp"] = "GBP";
    ICurrencyCode["Gel"] = "GEL";
    ICurrencyCode["Ghs"] = "GHS";
    ICurrencyCode["Gnf"] = "GNF";
    ICurrencyCode["Gtq"] = "GTQ";
    ICurrencyCode["Hkd"] = "HKD";
    ICurrencyCode["Hnl"] = "HNL";
    ICurrencyCode["Hrk"] = "HRK";
    ICurrencyCode["Huf"] = "HUF";
    ICurrencyCode["Idr"] = "IDR";
    ICurrencyCode["Ils"] = "ILS";
    ICurrencyCode["Inr"] = "INR";
    ICurrencyCode["Iqd"] = "IQD";
    ICurrencyCode["Irr"] = "IRR";
    ICurrencyCode["Isk"] = "ISK";
    ICurrencyCode["Jmd"] = "JMD";
    ICurrencyCode["Jod"] = "JOD";
    ICurrencyCode["Jpy"] = "JPY";
    ICurrencyCode["Kes"] = "KES";
    ICurrencyCode["Khr"] = "KHR";
    ICurrencyCode["Kmf"] = "KMF";
    ICurrencyCode["Krw"] = "KRW";
    ICurrencyCode["Kwd"] = "KWD";
    ICurrencyCode["Kzt"] = "KZT";
    ICurrencyCode["Lbp"] = "LBP";
    ICurrencyCode["Lkr"] = "LKR";
    ICurrencyCode["Ltl"] = "LTL";
    ICurrencyCode["Lvl"] = "LVL";
    ICurrencyCode["Lyd"] = "LYD";
    ICurrencyCode["Mad"] = "MAD";
    ICurrencyCode["Mdl"] = "MDL";
    ICurrencyCode["Mga"] = "MGA";
    ICurrencyCode["Mkd"] = "MKD";
    ICurrencyCode["Mmk"] = "MMK";
    ICurrencyCode["Mop"] = "MOP";
    ICurrencyCode["Mur"] = "MUR";
    ICurrencyCode["Mxn"] = "MXN";
    ICurrencyCode["Myr"] = "MYR";
    ICurrencyCode["Mzn"] = "MZN";
    ICurrencyCode["Nad"] = "NAD";
    ICurrencyCode["Ngn"] = "NGN";
    ICurrencyCode["Nio"] = "NIO";
    ICurrencyCode["Nok"] = "NOK";
    ICurrencyCode["Npr"] = "NPR";
    ICurrencyCode["Nzd"] = "NZD";
    ICurrencyCode["Omr"] = "OMR";
    ICurrencyCode["Pab"] = "PAB";
    ICurrencyCode["Pen"] = "PEN";
    ICurrencyCode["Php"] = "PHP";
    ICurrencyCode["Pkr"] = "PKR";
    ICurrencyCode["Pln"] = "PLN";
    ICurrencyCode["Pyg"] = "PYG";
    ICurrencyCode["Qar"] = "QAR";
    ICurrencyCode["Ron"] = "RON";
    ICurrencyCode["Rsd"] = "RSD";
    ICurrencyCode["Rub"] = "RUB";
    ICurrencyCode["Rwf"] = "RWF";
    ICurrencyCode["Sar"] = "SAR";
    ICurrencyCode["Sdg"] = "SDG";
    ICurrencyCode["Sek"] = "SEK";
    ICurrencyCode["Sgd"] = "SGD";
    ICurrencyCode["Sos"] = "SOS";
    ICurrencyCode["Syp"] = "SYP";
    ICurrencyCode["Thb"] = "THB";
    ICurrencyCode["Tnd"] = "TND";
    ICurrencyCode["Top"] = "TOP";
    ICurrencyCode["Try"] = "TRY";
    ICurrencyCode["Ttd"] = "TTD";
    ICurrencyCode["Twd"] = "TWD";
    ICurrencyCode["Tzs"] = "TZS";
    ICurrencyCode["Uah"] = "UAH";
    ICurrencyCode["Ugx"] = "UGX";
    ICurrencyCode["Usd"] = "USD";
    ICurrencyCode["Uyu"] = "UYU";
    ICurrencyCode["Uzs"] = "UZS";
    ICurrencyCode["Vef"] = "VEF";
    ICurrencyCode["Vnd"] = "VND";
    ICurrencyCode["Xaf"] = "XAF";
    ICurrencyCode["Xof"] = "XOF";
    ICurrencyCode["Yer"] = "YER";
    ICurrencyCode["Zar"] = "ZAR";
    ICurrencyCode["Zmw"] = "ZMW";
    ICurrencyCode["Zwl"] = "ZWL";
})(ICurrencyCode || (ICurrencyCode = {}));
export { IDocumentColors };
var IDocumentColors;
(function (IDocumentColors) {
    IDocumentColors["Blue"] = "blue";
    IDocumentColors["Green"] = "green";
    IDocumentColors["Purple"] = "purple";
    IDocumentColors["Red"] = "red";
    IDocumentColors["Yellow"] = "yellow";
})(IDocumentColors || (IDocumentColors = {}));
export { IDocumentStatus };
var IDocumentStatus;
(function (IDocumentStatus) {
    IDocumentStatus["Draft"] = "draft";
    IDocumentStatus["New"] = "new";
    IDocumentStatus["Ready"] = "ready";
    IDocumentStatus["Trash"] = "trash";
})(IDocumentStatus || (IDocumentStatus = {}));
export { IGender };
var IGender;
(function (IGender) {
    IGender["Div"] = "div";
    IGender["Female"] = "female";
    IGender["Male"] = "male";
})(IGender || (IGender = {}));
export { IPaymentProtoStrategy };
var IPaymentProtoStrategy;
(function (IPaymentProtoStrategy) {
    IPaymentProtoStrategy["Representation"] = "representation";
    IPaymentProtoStrategy["Source"] = "source";
})(IPaymentProtoStrategy || (IPaymentProtoStrategy = {}));
export { IPaymentType };
var IPaymentType;
(function (IPaymentType) {
    IPaymentType["Bank"] = "bank";
    IPaymentType["Fe"] = "fe";
    IPaymentType["Kasse"] = "kasse";
    IPaymentType["Payment"] = "payment";
    IPaymentType["Verrechnung"] = "verrechnung";
})(IPaymentType || (IPaymentType = {}));
export { IProductAccessLevel };
var IProductAccessLevel;
(function (IProductAccessLevel) {
    IProductAccessLevel["Read"] = "read";
    IProductAccessLevel["Write"] = "write";
})(IProductAccessLevel || (IProductAccessLevel = {}));
export { IProductKey };
var IProductKey;
(function (IProductKey) {
    IProductKey["Bank"] = "Bank";
    IProductKey["Banks"] = "Banks";
    IProductKey["Contacts"] = "Contacts";
    IProductKey["Dms"] = "DMS";
    IProductKey["Deb"] = "Deb";
    IProductKey["Er"] = "ER";
    IProductKey["ErA"] = "ER_A";
    IProductKey["Fe"] = "FE";
    IProductKey["Invoices"] = "Invoices";
    IProductKey["Kb"] = "KB";
    IProductKey["La"] = "LA";
    IProductKey["Lager"] = "Lager";
    IProductKey["Ocr"] = "OCR";
    IProductKey["Pos"] = "POS";
})(IProductKey || (IProductKey = {}));
export { ISaveSummaryAction };
var ISaveSummaryAction;
(function (ISaveSummaryAction) {
    ISaveSummaryAction["Cancelled"] = "cancelled";
    ISaveSummaryAction["Created"] = "created";
    ISaveSummaryAction["Removed"] = "removed";
    ISaveSummaryAction["Updated"] = "updated";
})(ISaveSummaryAction || (ISaveSummaryAction = {}));
export { ITextTemplateType };
var ITextTemplateType;
(function (ITextTemplateType) {
    ITextTemplateType["Text1"] = "Text1";
    ITextTemplateType["Text2"] = "Text2";
})(ITextTemplateType || (ITextTemplateType = {}));
export { IUserRole };
var IUserRole;
(function (IUserRole) {
    IUserRole["DmsAdmin"] = "DMSAdmin";
    IUserRole["DmsNewDocuments"] = "DMSNewDocuments";
    IUserRole["DatevExporter"] = "DatevExporter";
    IUserRole["RecordReviewer"] = "RecordReviewer";
})(IUserRole || (IUserRole = {}));
//# sourceMappingURL=graphql.js.map